import { useCompany } from './CompanyLayout';
import ShopFloorPage from '../ShopFloorPage';

/**
 * Company-aware wrapper for the Shop Floor page
 * This allows the shop floor to access company context
 */
export default function CompanyShopFloor() {
  const { company } = useCompany();

  // Pass company context to the shop floor
  // The ShopFloorPage can optionally use this to:
  // - Save/load layouts per company
  // - Display company-specific machines
  // - Connect to company-specific simulation
  return <ShopFloorPage companyId={company?.id} companyName={company?.name} companySlug={company?.slug} />;
}
